import { createGlobalStyle } from "styled-components";
import { graiaPrimaryColor } from "./appTheme";

const GlobalStyle = createGlobalStyle`
  :root:root {
    --adm-color-primary: ${graiaPrimaryColor};
  }

  body {
    font-family: ${p => p.theme.fontFamily};
  }

  code {
    font-family: ${p => p.theme.fontFamilyCode};
  }

  .ant-typography {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
`;

export default GlobalStyle;
